import _axios from '@/assets/utils/_axios'
import { powerIsInArray } from '@/assets/utils/GlobalFunction'
import { _loading,_confirm,_alert } from '../../assets/utils/utils';
import { Message } from 'element-ui';
import GVAR from '@/assets/config/VariateConfig'
import Router from '@/router'
import { data } from 'jquery';

//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;
let Status='all';
export default {
  /*所有身份搜索订单的接口*/
  async searchOrder ({ commit, getters }, {data,successFun}) {
    console.log(data);
    //全部订单状态值重新处理
    Status=data?data.status:Status;
    let type;
    switch (getters.userInfo.type) {
      case 2:
        type=data&&data.status=='66'?'/pc/Travel/RecycleOrderHotelList':'/pc/Travel/OrderHotelList';
        break;
      case 3:
        type=data&&data.status=='66'?'/pc/Hotel/RecycleOrderHotelList':'/pc/Hotel/OrderHotelList';
        break;
      case 99:
        type='/pc/Admin/OrderHotelList'
        break;
    };
    if (Status === 'all'&&data || data&&data.status==='66') delete data.status
    let res = await _axios.post(type,{//searchOrderList
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      store_id: getters.storeInfo.storeId,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists,total,user_list
      if(res.data){
        lists=res.data.list||res.info.data||[];
        total= res.data.count ||res.data.total_num ||0;
        user_list= res.data.user_list||[];
        user_list.unshift({truename:'全部',uid:'0'})
      }else{
        lists=[];
      }
      commit('UPDATEORDERNUMINFO',res.data.info);
      commit('UPDATEORDERLISTS', lists)
      commit('UPDATEORDERTOTAL', total)
      commit('UPDATEORDERUSERLIST',user_list);
      successFun();
    }
  },
  /*采购商业务管理*/
  async businessList({ commit, getters }, { data, successFun }){
    console.log(data);
      let date={
        num: 30,
        store_id: getters.storeInfo.storeId,
        ...data
      }
      let res = await _axios.post('/pc/Travel/BrokerOrderHotelList',date);
      if(res.code === '00000') successFun(res.data) 
      let lists = res.data.list||[];
      let total = res.data.count||0;
      // commit('UPDABUSINESSLIST', lists);
      // commit('UPDATEORDERTOTAL', total);
  },
    /*采购商酒店提现列表*/
  async businessPayment({ commit, getters }, { data, successFun }){
    console.log(data);
      let date={
        num: NUM,
        ...data
      }
      let url=getters.userInfo.type==2?'/pc/Travel/PaymentRecordList':'/pc/Hotel/PaymentRecordList';
      let res = await _axios.post(url,date);
      if(res.code === '00000') successFun(res.data) 
      let lists = res.data.list||[];
      let total = res.data.count||0;
      // commit('UPDABUSINESSLIST', lists);
      // commit('UPDATEORDERTOTAL', total);
  },
  /*采购商编辑业务管理*/
  async businessEdit({ commit, getters }, { data, successFun }){
      let date={
        store_id: getters.storeInfo.storeId,
        ...data
      }
      let res = await _axios.post('/pc/Travel/BrokerOrderHotelSetBGColor',date);
      if(res.code === '00000') successFun(res.data) 
      // commit('UPDABUSINESSLIST', lists);
      // commit('UPDATEORDERTOTAL', total);
  },
  /*采购商提交提现申请*/
  async businessWithdraw({ commit, getters }, { data, successFun }){
      let date={
        store_id: getters.storeInfo.storeId,
        ...data
      }
      let res = await _axios.post('/pc/Travel/OrderHotelWithdraw',date);
      if(res.code === '00000') successFun(res.data) 
      // commit('UPDABUSINESSLIST', lists);
      // commit('UPDATEORDERTOTAL', total);
  },
  //采购商、管理员设置导游时获取全部导游
  async getGuide ({commit,getters,state},{ data, successFun }) {
    let url = '/pc/Travel/GuideList';
    if (data.all_flag == 1) { url = '/pc/Travel/LeaderList'}
    delete data.tab;delete data.store_type;
    let res = await _axios.post(url, { ...data});
    if (res.code === '00000' || res.code == '99999') successFun(res) 
    else Message.warning(res.msg)
  },
  //采购商、管理员确定选择导游
  async enSure ({commit,getters,state},{ chooseGuide,flag, successFun }) {
    let res = await _axios.post('/pc/Travel/OrderHotelSetVerify', {
        store_id: getters.storeInfo.storeId,
        oid: state.OrderDetail.oid,
        id: chooseGuide.id,
        flag:flag
    });
    if (res.code === '00000') successFun()
  },
  // 采购商、管理员删除导游
  async delGuide ({ commit,getters,state }, {successFun,id,flag}) {
    _confirm('确定删除该人员么？',async () => {
      let url = '/pc/Travel/OrderHotelDelVerify'
      // if (getters.storeInfo.type == 99) url = 'pc/Admin/delOrderGuide'
      let res = await _axios.post(url,{
        store_id: getters.storeInfo.storeId,
        oid: state.OrderDetail.oid,
        id: id,
        flag:flag
      });
      if (res.code === '00000') successFun()
    })
  },
  //采购商、管理员确定选择支付人
  async payer ({commit,getters,state},{ chooseGuide,flag, successFun }) {
    if (JSON.stringify(chooseGuide) == '{}') { Message.warning('请先选择支付人'); return }
    let name='';
    switch (flag) {
      case 1:name=100; break;
      default:
        name=chooseGuide.flag;break;
    }
    let res = await _axios.post('/pc/Travel/OrderHotelSetPay', {
        store_id: getters.storeInfo.storeId,
        oid: state.OrderDetail.oid,
        id: chooseGuide.id,
        flag:name
    });
    if (res.code === '00000') successFun()
  },
    //采购商、管理员删除支付人
    async payerDelete ({commit,getters,state},{successFun,id,flag}) {
      _confirm('确定删除该人员么？',async () => {
        let url = '/pc/Travel/OrderHotelDelPay'
        // if (getters.storeInfo.type == 99) url = 'pc/Admin/delOrderGuide'
        let res = await _axios.post(url,{
          store_id: getters.storeInfo.storeId,
          oid: state.OrderDetail.oid,
          id: id,
          flag:flag
        });
        if (res.code === '00000') successFun()
      })
    },
  /*采购商获取酒店、民宿、景区订单列表*/
  async tGetOrderLists ({ commit, getters }, data) {
    //全部订单状态值重新处理
    Status=data?data.status:Status;
    if (Status === 'all') delete data.status
    let loading = _loading({ target: '.load-area' });
    let type = data.order_style,
        url = type === 1 ? '/pc/Travel/getYearCardOrderList' : '/pc/Travel/orderManage';
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      status: '',
      order_style: '',
      ...data
    })
    loading.close()
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data ? res.data.info : [];
      let total = res.data ? res.data.total_num : 0;
      if (type === 1) {
        lists = res.data || [];
        total = res.count || 0;
      }
      lists.forEach(v => {
        v.appointName = v.appoint_name;
      })
      commit('UPDATEORDERLISTS', lists)
      commit('UPDATEORDERTOTAL', total)
      
    }
  },
  /*管理员获取酒店、民宿、景区、年卡订单列表*/
  async aGetOrderLists ({ commit, getters }, {type,data,successFun}) {
    //全部订单状态值重新处理
    Status=data?data.status:Status;
    if (Status === 'all'&&data) delete data.status
    let url = '',postData = {
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      ...data
    };
    switch (type) {
      case 3:
        url = '/pc/Admin/OrderHotelList';
        postData.order_style = 3;
        break;
      case 5:url = '/pc/Admin/getHomestayOrder'; break;
      case 6:url = '/pc/Admin/getViewpointOrderList'; break;
      case 7:url = '/pc/Admin/getVocationOrderList'; break;
      case 8:url = '/pc/Admin/getBrandhallOrderList'; break;
      case 1:url = '/pc/Admin/getYearcardOrderList'; break;
      case 9:url = '/pc/Admin/OrderHotelPendingList'; break;
      default:break;
    }
    let res = await _axios.post(url, postData)
    if (res.code === '00000' || res.code === '99999') {
      let lists = [];
      let total = 0;
      switch (type) {
        case 3: case 7:
          lists = res.data.list||[];
          total = res.data.count|| 0;
          break;
        default:
          lists = res.data.list||[];
          total = res.data.count|| 0;
          break;
      }
      successFun();
      commit('UPDATEORDERLISTS', lists);
      commit('UPDATEORDERTOTAL', total);
      commit('UPDATEORDERNUMINFO',res.data.info);
    }
  },
  //===============================住宿订单操作部分=====================================
  /*酒店待报价/管理员待处理订单列表*/
  async hGetOrderOffer ({ commit, getters },  {type,data,successFun}) {
    //全部订单状态值重新处理
    Status=data?data.status:Status;
    if (Status === 'all'&&data) delete data.status;
     let url = '',postData={}
    switch (type) {
      case 2:
        url = getters.userInfo.type==2?'/pc/Travel/OrderHotelList':'/pc/Hotel/OrderHotelList'; 
        postData={
          store_id:getters.storeInfo.storeId,
          num: NUM,
          page: Router.currentRoute.query.page || 1,
          ...data,
        }
      break;
      case 3:
        url = '/pc/Hotel/HotelOfferList'; 
        postData={
          store_id:getters.storeInfo.storeId,
          num: NUM,
          page: Router.currentRoute.query.page || 1,
          ...data
        }
      break;
      case 99:
        url = '/pc/Admin/OrderHotelPendingList'; 
        postData={
          num: NUM,
          page: Router.currentRoute.query.page || 1,
          ...data
        }
      break;
    }
    delete postData.uid;
    let res = await _axios.post(url, postData)
    if (res.code === '00000' || res.code === '99999') {
      let  lists=res.data.list||[];
      let  total= res.data.count|| 0;
      let info={
        status_0:res.data.count,
        ...res.data.info
      }
      successFun();
      commit('UPDATEORDERNUMINFO',info);
      commit('UPDATEQUOTATION', lists)
      commit('UPDATEORDERTOTAL', total)
    }
  },
  /*酒店待报价/管理员待处理订单列表*/
  async POST_OrderHotelListConfirm ({ commit, getters },  {data,successFun}) {
    let postData={
          num: NUM,
          page: Router.currentRoute.query.page || 1,
          ...data,
          store_id:getters.isGroup ? getters.storeInfo.grostoreId : getters.storeInfo.storeId,
          status:getters.userInfo.type==2?'5':'',
    }
    let  url=getters.userInfo.type==2?'/pc/Travel/OrderHotelList':'/pc/Hotel/OrderHotelListConfirm';
    let res = await _axios.post(url, postData)
    if (res.code === '00000' || res.code === '99999') {
      let  lists=res.data.list||[];
      let  total= res.data.count|| 0;
      let info={
        status_0:res.data.count,
        ...res.data.info
      }
      successFun();
      commit('UPDATEORDERNUMINFO',info);
      commit('UPDATEQUOTATION', lists)
      commit('UPDATEORDERTOTAL', total)
    }
  },
  /*酒店获取订单列表*/
  async hGetOrderLists ({ commit, getters }, {data,successFun}) {
    //全部订单状态值重新处理
    Status=data?data.status:Status;
    if(data.store_id==0){
      data.store_id=getters.isGroup ? getters.storeInfo.grostoreId : getters.storeInfo.storeId
    }
    let url=data.status=='66'?'/pc/Hotel/RecycleOrderHotelList':'/pc/Hotel/OrderHotelList';
    if (Status === 'all'||data.status==='66'&&data) delete data.status
    let res = await _axios.post(url, {
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      status:'',
      ...data,
          store_id:getters.storeInfo.storeId,
    })
    if (res.code === '00000' || res.code === '99999') {
      let  lists=res.data.list||[];
      let  Hotellist= res.data.user_list || [];
      let  total= res.data.count|| 0;
      Hotellist.unshift({truename:'全部',uid:0});
      commit('UPDATEORDERNUMINFO',res.data.info);
      commit('UPDATEORDERLISTS', lists);  
      commit('UPDATEORDERTOTAL', total);
      commit('UPDATEORDERHOTELLIST', Hotellist);
      successFun();
    }
  },
  /*酒店发起收款*/
  async hGetOrderTradeList ({ state, getters,dispatch },{data,successFun}) {
    let loading = _loading({ text:'正在通知...',target: '.load-area' });
    let res = await _axios.post('/pc/Hotel/OrderHotelCollectMoney',data);
      loading.close();
    if (res.code === '00000') successFun()
       
  },
  /*采购商发布订单、采购商/酒店修改订单*/
  async travelPostOrder ({ dispatch,commit, getters }, {data,successFun,successNone}) {
    let hotelId = Router.currentRoute.query.hotel;
    let url=data.modify?'/pc/Travel/SendOrderHotel':getters.userInfo.type==2?'/pc/Travel/StartEditOrderHotel':'pc/Hotel/StartEditOrderHotel';
    if (!hotelId) delete data.hotel_id;               //暂时以hotel_id判断定向 / 匹配类型，当路由没有hotel时删除该属性
    let loading = _loading({ text:'订单发布中...',target: '#loadConfirm' });
    delete  data.modify;
    let res = await _axios.post(url, { ///pc/Travel/send_order
      store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
      ...data
    });
    loading.close();
    if (res.code === '00000') {
      successFun();
      dispatch('getUserIndexData');
    }
    if (res.code === '10180') successNone(res.msg);
  },
  /*管理员重新编辑订单时显示页面信息*/
  async adminEditOrderPre ({ commit, getters }, orderId) {
    let res = await _axios.post('/pc/Admin/customExamineOrder', {
      id:orderId
    });
    if (res.code === '00000') {
      let orderPostPre = {
        contact:res.data.contact,
        orderInfo:res.data.order || {}
      }
      commit('UPDATEORDERPOSTPRE',orderPostPre);
    }
  },
  /*管理员提交重新编辑住宿订单*/
  async adminEditOrder ({ commit, getters }, {data,successFun}) {
    let loading = _loading({ text:'订单保存中...',target: '.load-area' });
    let res = await _axios.post('/pc/Admin/customEditOrder', data);
    loading.close();
    if (res.code === '00000') successFun();
  },
  /*管理员审核住宿订单*/
  async adminVerifyOrder ({ state, getters,dispatch }, {data,successFun}) {
    let loading = _loading({ text:'订单审核中...',target: '.load-area' }),url;
    switch (data.flag) {
      case 2:
        url = '/pc/Admin/VerifyOrderHotel';
        break
      case 3:
        url = '/pc/Admin/MatchAndPushOrderHotel';
        break
      case 4:
        url = '/pc/Admin/PushOrderHotel';
        break
    }
    let res = await _axios.post(url, {
        oid:data.oid,
    });
    loading.close();
    if (res.code === '00000') _alert('操作成功',() => {
      successFun();
    })
  },
  /*管理员获取订单匹配结果*/
  async adminGetMatchLists ({ state, getters,commit },{data,successFun}) {
    let loading = _loading({ text:'正在获取匹配结果，请稍后...',target: '.load-area' });
    let res = await _axios.post('/pc/Admin/ShowMatchOrderHotel',data);
    loading.close();
    if (res.code === '00000') 
    commit('UPDATEMATCHRESULT',{
      // hotelList:res.data.list,
      matchInfo:{...res.data.match,...res.data.push},
      status:res.data.status
    })
    successFun(res);
  },
  /*管理员通知酒店报价*/
  async adminInformHotel ({ state, getters,dispatch },data) {
    let loading = _loading({ text:'正在通知酒店...',target: '.load-area' });
    if (!data.isAppoint) delete data.isAppoint;
    let res = await _axios.post('/pc/Admin/PushErrorOrderHotel', data);
    loading.close();
    if (res.code === '00000') {
      if (data.isAppoint) {
        let msg = GVAR.wechatCode.filter(v => v.id == res.push)[0] || {}
        _alert(msg,() => dispatch('GetOrderDetail',data.id))
      } else dispatch('adminGetMatchLists',data.id)
    }
  },
  /*采购商、酒店、管理员获取住宿订单详情*/
  async GetOrderDetail ({ commit, getters }, orderId) {
      let t = getters.storeInfo.type, url = '', data = {};
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelDetail';
          data.store_id = getters.storeInfo.storeId;
          data.oid = orderId;
          break
        case 3:
          url = '/pc/Hotel/OrderHotelDetail';
          data.store_id = getters.storeInfo.storeId;
          data.oid = orderId;
          break
        case 99:
          url = '/pc/Admin/OrderHotelDetail';
          data.oid = orderId;
          break
      }
      let res = await _axios.post(url, data);
      if (res.code === '00000') {
        let resInfo = res.data.info || res.info;
        resInfo.offer_time=res.data.offer&&res.data.offer.list.length!=0?res.data.offer.list[0].offer_time||'': resInfo.offer_time;
        switch (t) {
          case 3:
            let i=[];
            if(res.data.select_hotel)i.push(res.data.select_hotel);
            resInfo.meetArr = res.data.meeting_need_arr || [];
            resInfo.roomArr = res.data.room_need_arr|| [];
            resInfo.my_offer=res.data.my_offer?res.data.my_offer.list:i||[];
            if(resInfo.status==97||resInfo.status==99){
              resInfo.my_offer=res.data.my_offer.list;
            }
            resInfo.match_hotel_list=res.data.match_hotel_list|| [];
            for(let i in resInfo.my_offer){
              if(resInfo.my_offer[i]&&resInfo.my_offer[i].meeting_offer_arr){
                let my_offer=resInfo.my_offer[i]
                if(my_offer.room_offer_arr.length!=0){
                  resInfo.my_offer[i].rmine=1
                }
                if(my_offer.meeting_offer_arr.length!=0){
                  resInfo.my_offer[i].rmine=2
                }
                if(my_offer.meeting_offer_arr.length==0&&my_offer.room_offer_arr==0){
                  resInfo.my_offer[i].rmine=3
                }
              }
            }
            resInfo.hotelLists = res.data.offer?res.data.offer.list:[];
            break;
          case 2:
            commit('UPDATEOFFERLISTS', res.data.offer?res.data.offer.list:[]);
            resInfo.roomArr = res.data.room_need_arr|| [];
            resInfo.meetArr = res.data.meeting_need_arr || [];
            break;
          case 99:
            commit('UPDATEOFFERLISTS', res.data.offer?res.data.offer.list:[]);
            resInfo.roomArr = res.data.room_need_arr|| [];
            resInfo.meetArr = res.data.meeting_need_arr || [];
        }
        //前台电话
        resInfo.hotel_tel=res.data.select_hotel?res.data.select_hotel.hotel_tel:'';
        resInfo.select_hotel=res.data.select_hotel;
        commit('UPDATEORDERDETAIL', resInfo);
      }
  },
  /*采购商获取住宿订单报价列表*/
  async GetOfferMess ({ commit, getters }, orderId) {
    let res = await _axios.post('/pc/Travel/getHotelOfferMess', {
      id: orderId
    });
    let arr = res.data || [];
    let nochoose = res.noChoose;
    let choose = res.chooseShop || [];
    choose.forEach(v => {
      v.title = v.hotel_name;
      v.star = v.hotel_star[0];
      v.teaBreakPrice = v.hotel_offer[0].tea_break_price;
      v.mealPrice = v.hotel_offer[0].meal_price;
      v.hotel_offer.forEach(t => {
        t.type = t.order_room_meeting_type;
        t.style = t.room_meetimg_style;
        t.HRoomPrice = (t.room_price / t.room_num).toFixed(2);
        t.TRoomPrice = (t.travel_room_price / t.travel_num).toFixed(2);
        t.HRoomNum = t.room_num;
        t.TRoomNum = t.travel_num;
        t.RoomName = t.room_meeting_name;
        t.roomMeetId = t.room_meeting_id;
        t.HMeetPrice = t.meeting_price;
        t.TMeetPrice = t.travel_meeting_price;
        t.HLedPrice = t.led_price;
        t.TLedPrice = t.travel_led_price;
        t.needLed = Number(t.led) === 2;
        t.needProjector = Number(t.projector) === 2;
        t.HProjectorPrice = t.projector_price;
        t.TProjectorPrice = t.travel_projector_price;
      })
    })
    arr.forEach(v => {
      v.title = v.hotel_name;
      v.star = v.hotel_star[0];
      v.teaBreakPrice = v.hotel_offer[0].tea_break_price;
      v.mealPrice = v.hotel_offer[0].meal_price;
      v.hotel_offer.forEach(t => {
        t.type = t.order_room_meeting_type;
        t.style = t.room_meetimg_style;
        t.HRoomPrice = (t.room_price / t.room_num).toFixed(2);
        t.TRoomPrice = (t.travel_room_price / t.travel_num).toFixed(2);
        t.HRoomNum = t.room_num;
        t.TRoomNum = t.travel_num;
        t.RoomName = t.room_meeting_name;
        t.roomMeetId = t.room_meeting_id;
        t.HMeetPrice = t.meeting_price;
        t.TMeetPrice = t.travel_meeting_price;
        t.HLedPrice = t.led_price;
        t.TLedPrice = t.travel_led_price;
        t.needLed = Number(t.led) === 2;
        t.needProjector = Number(t.projector) === 2;
        t.HProjectorPrice = t.projector_price;
        t.TProjectorPrice = t.travel_projector_price;
      })
    })
    if (res.code === '00000' || res.code === '99999') {
      commit('UPDATEOFFERLISTS', arr);
      commit('UPDATENOCHOOSE', nochoose);
      commit('UPDATECHOOSE', choose);
      commit('UPDATEHOTELSHOPCAR', res.choose || []);
    }
  },
  /*酒店报价*/
  async HotelOfferPrice ({ commit, getters,dispatch }, {data,successFun}) {
    let res = await _axios.post('/pc/Hotel/HotelOffer', {
      ...data,
    });
    if (res.code === '00000') {
      successFun();
    }
  },
  /*酒店回复满房*/
  async replyRefuse ({ dispatch, getters,state },{data,successFun,}) {
    let res = await _axios.post('/pc/Hotel/HotelUnable', {
        ...data
    });
    if (res.code === '00000') {
        successFun();
    }
  },
  /*采购商提交还价*/
  async TravelBargainPrice ({ commit, getters }, {data,successFun}) {
    let res = await _axios.post('/pc/Travel/travelCountOfferToHotel', {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*采购商将酒店加入购物车*/
  async addHotelToShopCar ({ commit, getters }, {data,successFun}) {
    let res = await _axios.post('/pc/Travel/travelChooseHotel', {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*采购商将酒店移出购物车*/
  async removeHotelFromShopCar ({ commit, getters }, {orderId,hotelId,successFun}) {
    let res = await _axios.post('/pc/Travel/travelRemoveChooseHotel', {
      store_id: getters.storeInfo.storeId,
      orderId,
      hotelId
    });
    if (res.code === '00000') successFun();
  },
  /*酒店修改报价、接收还价、拒绝还价*/
  async editHotelOffer ({ commit, getters }, {data,successFun}) {
    let res = await _axios.post('/pc/Hotel/editHotelOrderOffer', {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') _alert('操作成功',successFun)
  },
  /*采购商提交订单*/
  async travelSubmitOrder ({ commit, getters },{orderId,successFun}) {
    let res = await _axios.post('/pc/Travel/travelSubmitOrder', {
      store_id: getters.storeInfo.storeId,
      orderId
    });
    if (res.code === '00000') successFun();
  },

  // 采购商提交品牌馆订单
  async travelBrandSubmit ({getters},{data,successFun}) {
    let res = await _axios.post('pc/Travel/submitBrandhallOrder', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*采购商选中酒店*/
  async ensureCheckIn ({dispatch, getters,state},{hoid,oid,successFun}) {
    let res = await _axios.post('/pc/Travel/DealOrderHotel', {
      store_id: getters.storeInfo.storeId,
      hoid: hoid,
      oid: oid,
    });
    if (res.code === '00000') successFun();
  },
  // /*酒店确认有房（同意入住）*/
  // async ensureCheckIn ({ dispatch, getters,state }) {
  //   let res = await _axios.post('/pc/Hotel/checkInHouse', {
  //     store_id: getters.storeInfo.storeId,
  //     oid: state.OrderDetail.oid,
  //   });
  //   if (res.code === '00000') {
  //     _alert('操作成功',() => {
  //       dispatch('GetOrderDetail',state.OrderDetail.oid);
  //       Message.success({
  //         showClose: true,
  //         customClass: 'activeSty',
  //         center: true,
  //         message: '预订成功，活跃值+' + (Math.floor(Number(state.OrderDetail.price) * 0.1)),
  //         type: 'success'
  //       })
  //     })
  //   }
  // },
  /*采购商取消订单*/
  async cancellationOfOrder ({getters},{oid,successFun,sms_code,cancel_type,ask_type}) {
    let url=ask_type==1&&getters.userInfo.type==3?'/pc/User/CancelOrderHotelConfirm':'/pc/Travel/CancelOrderHotel'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      cancel_type,
      oid:oid,
      sms_code
    });
    if (res.code === '00000') successFun();
    //successFun();
  },
  /*还原订单*/
  async restoreOrder ({getters},{oid,switchs,successFun}) {
    let t = getters.storeInfo.type, url = '',data;
    switch (t) {
      case 2:
        url = switchs==1?'/pc/Travel/BatchRestoreDelOrderHotel':'/pc/Travel/RestoreOrderHotel';
        data={
          [switchs==1?'oid_list':'oid']: oid
        }
        break
      case 3:
        url = switchs==1?'/pc/Hotel/BatchRestoreDelOrderHotel':'/pc/Hotel/RestoreOrderHotel';
        data={
          [switchs==1?'hoid_list':'hoid']: oid
        }
        break
    }
    let res = await _axios.post(url, {
      ...data,
      store_id: getters.storeInfo.storeId,
    });
    if (res.code === '00000') successFun();
  },
  /*删除订单*/
  async cancellationDelOrderHotel ({getters},{oid,orderStatus,successFun}) {
    let t = getters.storeInfo.type, url = '',data;
    switch (t) {
      case 2:
        url = orderStatus=='66'?'/pc/Travel/BatchPermanentDelOrderHotel':'/pc/Travel/DelOrderHotel';
        data={
          [orderStatus=='66'?'oid_list':'oid']: oid
        }
        break
      case 3:
        url = orderStatus=='66'?'/pc/Hotel/BatchPermanentDelOrderHotel':'/pc/Hotel/DelOrderHotel';
        data={
          [orderStatus=='66'?'hoid_list':'hoid']: oid
        }
        break
      case 99:
        url = '/pc/Admin/getHomestayOrderDetail';
        break
    }
    let res = await _axios.post(url, {
      ...data,
      store_id: getters.storeInfo.storeId,
    });
    if (res.code === '00000') successFun();
  },
  /*标记订单*/
  async OrderHotelFlag ({getters},{oid,successFun}) {
    let t = getters.storeInfo.type, url = '';
    switch (t) {
      case 2:
        url = '/pc/Travel/OrderHotelFlag';
        break
      case 3:
        url = '/pc/Hotel/OrderHotelFlag';
        break
      case 99:
        url = '/pc/Admin/OrderHotelFlag';
        break
    }
      let res = await _axios.post(url, {
        store_id: getters.storeInfo.storeId,
        ...oid,
      });
      if (res.code === '00000') successFun();
    },
    /*采购商、酒店查看修改订单*/
    async OrderHotelDetail ({ commit, getters }, {oid,successFun}) {
        let res = await _axios.post('/pc/User/EditOrderHotelDetail', {
            ...oid,
        });
        if (res.code === '00000') successFun(res.data.info);
    },
    /*采购商、酒店查看修改订单*/
    async EditOrderHotel ({ dispatch,commit, getters }, {oid,action,successFun}) {
      let t = getters.storeInfo.type, url = '';
      switch (t) {
          case 2:
            url = '/pc/Travel/EndEditOrderHotel';
            break
          case 3:
            url = '/pc/Hotel/EndEditOrderHotel';
            break
      }
      let res = await _axios.post(url, {
          store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
          oid:oid,
          action:action,
      });
      if (res.code === '00000') {
        dispatch('getUserIndexData');
        successFun();
      }
    },
    /*采购商、酒店撤回修改订单*/
    async EditRevoke ({ dispatch,commit, getters }, {oid,successFun}) {
      let t = getters.storeInfo.type, url = '';
      switch (t) {
          case 2:
            url = '/pc/Travel/RevokeEditOrderHotel';
            break
          case 3:
            url = '/pc/Hotel/RevokeEditOrderHotel';
            break
      }
      let res = await _axios.post(url, {
          store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
          oid:oid,
      });
      if (res.code === '00000') {
        successFun();
      }
  },
  /*采购商完成订单*/
  // travelComplete({ dispatch, getters,state }) {
  //   _confirm('确定订单尾款已结清并结束订单么？',async () => {
  //     let res = await _axios.post('/pc/Travel/EndOrderHotel', {
  //       store_id: getters.storeInfo.storeId,
  //       oid: state.OrderDetail.oid,
  //     });
  //     if (res.code === '00000') _alert('已完成订单',() => {Router.back()})
  //     //dispatch('GetOrderDetail',state.OrderDetail.oid)
  //   })
  // },
    /*采购商完成订单*/
  async travelComplete ({ commit, getters },{oid,successFun}) {
    let res = await _axios.post('/pc/Travel/EndOrderHotel', {
      store_id: getters.storeInfo.storeId,
      oid
    });
    if (res.code === '00000') successFun();
  },
  /*采购商发布和重新发布订单时显示页面信息*/
  async travelPostOrderPre ({ commit, getters }, orderId) {
    commit('UPDATEORDERPOSTPRE',getters.adminInfo);
    // let res = await _axios.post('/pc/Travel/show_send_order', {
    //   store_id: getters.storeInfo.storeId,
    //   // id:orderId
    // });
    // if (res.code === '00000') {
    //   let orderPostPre = {
    //     contact:res.data.contact,
    //     orderInfo:res.data.order || {}
    //   }
    // }
  },
    /*管理员订单提交财务*/
  adminSubmitFinance ({ dispatch, getters,state},{type,data,successFun}) {
   
    _confirm('每个订单对应门店只能打款一次，确定款项已支付完结?',async () => {
      let url=type==3?'/pc/Admin/SubmitFinanceHotel':'/pc/Admin/SubmitFinanceTravel'
      let res = await _axios.post(url,data);
      if (res.code === '00000') successFun();
    })
  },
  /*管理员拒绝采购商提现申请  */
  adminSubmitRefuse ({ dispatch, getters,state},{data,successFun}) {
   
    _confirm('是否拒绝该提现申请？',async () => {
      let res = await _axios.post('/pc/Admin/TravelWithdrawNoPass',data);
      if (res.code === '00000') successFun();
    })
  },
  /*管理员订单修改提交财务*/

  adminSubmitModify ({ dispatch, getters,state},{data,successFun}) {
   
    _confirm('是否修改该打款手续费信息？',async () => {
      console.log(data)
      let res = await _axios.post('/pc/Admin/EditFinance',data);
      if (res.code === '00000') successFun();
    })
  },
  /*管理员确认打款*/
  adminPayment ({ dispatch, getters,state},{data,successFun}) {
   
    _confirm('确定该订单已完成打款么？',async () => {
      let res = await _axios.post('/pc/Admin/Payment', {
        ...data
      });
      if (res.code === '00000') successFun();
    })
  },
  /*管理员修改回单号*/
  adminPaymentModify ({ dispatch, getters,state},{data,successFun}) {
   
    _confirm('确定要修改回单号信息么？',async () => {
      let res = await _axios.post('/pc/Admin/EditPayment', {
        ...data
      });
      if (res.code === '00000') successFun();
    })
  },
  /*管理员打款撤销提交*/
  adminPaymentRevoke ({ dispatch, getters,state},{data,successFun}) {
   
    _confirm('确定要撤销此打款信息么？',async () => {
      let res = await _axios.post('/pc/Admin/RevokeFinance', {
        ...data
      });
      if (res.code === '00000') successFun();
    })
  },
  /*管理员查看订单详细*/
  async adminTradeInfo ({ dispatch, getters,state},{data,successFun}) {
   
      let res = await _axios.post('/pc/Admin/TradeInfo', {
        ...data
      });
      if (res.code === '00000') successFun(res.data);
  },
  /*管理员中止订单*/
  adminCancelOrder ({ dispatch, getters,state }) {
   
    _confirm('确定将该订单取消么？',async () => {
      let res = await _axios.post('/pc/Admin/adminCancelOrder', {
        orderId: state.OrderDetail.id,
      });
      if (res.code === '00000') dispatch('GetOrderDetail',state.OrderDetail.id)
    })
  },
  /*管理员完成订单*/
  adminEndOrder ({ dispatch, getters,state }) {
    _confirm('确定订单尾款已结清并结束订单么？',async () => {
      let res = await _axios.post('/pc/Admin/adminEndOrder', {
        id: state.OrderDetail.id,
      });
      if (res.code === '00000') dispatch('GetOrderDetail',state.OrderDetail.id)
    })
  },
  /*酒店、管理员修改订单订金、尾款、续住
  * 民宿、管理员修改订单金额、续住*/
  async ChangeHotelPrice ({ dispatch, getters,state },{type,data,successFun}) {
    let url = '',orderStatus = state.OrderDetail.status,a = getters.isAdmin;
    switch (type) {
      case 'hotel':     //住宿订单
        url = a ? '/pc/Admin/saveHotelFund' : '/pc/Hotel/setOrderPriceData';
        break;
      case 'homestay':  //民宿订单
        if (a) url = '/pc/Admin/editHomestayOrderPrice';
        else url = orderStatus === 8 ? '/pc/Homestay/editOrderPrice' : '/pc/Homestay/setContinued';
        break;
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') _alert('修改成功',() => {
      switch (type) {
        case 'hotel':
          if (successFun) successFun();
          dispatch('GetOrderDetail',data.oid);
          break;
        case 'homestay':dispatch('getHomestayOrderDetail',data.oid); break;
      }
    });
  },
  //===============================民宿订单操作部分=====================================
  /*采购商、民宿、管理员获取民宿订单详情*/
  async getHomestayOrderDetail({commit, getters},orderId) {
    let t = getters.storeInfo.type, url = '', data = {
      oid:orderId
    };
    switch (t) {
      case 2:
        url = '/pc/Travel/getHomestayOrderDetail';
        data.store_id = getters.storeInfo.storeId;
        break
      case 5:
        url = '/pc/Homestay/getOrderDetails';
        data.store_id = getters.storeInfo.storeId;
        break
      case 99:
        url = '/pc/Admin/getHomestayOrderDetail';
        break
    }
    let loading = _loading({ target: '.load-area' });
    let res = await _axios.post(url, data);
    loading.close();
    if (res.code === '00000' || res.code == '99999') {
      let resInfo = res.info || {};
      let cInfo = res.send_order_user_info || {};   //采购商的联系人在res.info，不在这个字段中
      resInfo.contactInfo = {
        linkName: cInfo.truename || resInfo.homestayContact,
        phoneNumber: cInfo.mobile || resInfo.homestayMob,
        companyName: cInfo.title || resInfo.homestayTitle,
        email: cInfo.email || '无相关信息',
        tel: cInfo.tel || resInfo.homestayTel ||  '无相关信息',
        fax: cInfo.fax || resInfo.homestayFax || '无相关信息'
      };
      resInfo.roomArr = res.homestay_room_arr || [];
      resInfo.actiArr = res.homestay_onsale_arr || [];
      resInfo.payList = res.payList || [];
      resInfo.surplus_pay = Number(res.info.surplus_pay) || ((Number(res.info.price) * 100 - res.info.price_pay) / 100).toFixed(2)
      resInfo.surplus_c_pay = Number(res.info.surplus_c_pay) || ((Number(res.info.continued_price) * 100 - res.info.continued_pay) / 100).toFixed(2)
      commit('UPDATEORDERDETAIL', resInfo);
    }
  },
  /*民宿获取订单列表*/
  async homeGetOrderLists ({ commit, getters }, data) {
    //全部订单状态值重新处理
    if (data.status === 'all') delete data.status
    let loading = _loading({ target: '.load-area' })
    let res = await _axios.post('/pc/Homestay/getOrderList', {
      store_id: getters.storeInfo.storeId,
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      status: '',
      ...data
    })
    loading.close()
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [];
      let total = res.total_nums || 0;
      commit('UPDATEORDERLISTS', lists)
      commit('UPDATEORDERTOTAL', total)
    }
  },
  /*民宿确认有房、回复满房*/
  async homestayReplay({commit, getters,dispatch},{flag,orderId}) {
    let url = flag ? '/pc/Homestay/homestayConfirm' : '/pc/Homestay/homestaySetFullHouse';
    let loading = _loading({ target: '.load-area' });
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      oid:orderId
    });
    loading.close();
    if (res.code === '00000') _alert('操作成功',() => {
      dispatch('getHomestayOrderDetail',orderId);
      dispatch('getWaitHandleData');
    });
  },
  //===============================品牌馆订单操作部分=====================================
  /*品牌馆获取订单列表*/
  async brandGetOrderLists ({ commit, getters }, data) {
    //全部订单状态值重新处理
    if (data.status === 'all') delete data.status
    //let loading = _loading({ target: '.load-area' })
    let res = await _axios.post('/pc/Brandhall/getOrderList', {
      store_id: getters.storeInfo.storeId,
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      status: '',
      ...data
    })
    //loading.close()
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [];
      let total = res.total_nums || 0;
      commit('UPDATEORDERLISTS', lists)
      commit('UPDATEORDERTOTAL', total)
    }
  },
  /**获取品牌馆订单详情 */
  async getBrandOrderDetail({commit, getters},orderId) {
    let t = getters.storeInfo.type, url = '', data = {
      store_id: getters.storeInfo.storeId,
      oid:orderId
    };
    switch (t) {
      case 2:
        url = '/pc/Travel/getBrandhallOrderDetails';
        break
      case 8:
        url = '/pc/Brandhall/getOrderDetails';
        break
      case 99:
        url = '/pc/Admin/getBrandhallOrderDetails';
        delete data.store_id
        break
    }
    let loading = _loading({ target: '.load-area' });
    let res = await _axios.post(url, data);
    loading.close();
    if (res.code === '00000' || res.code == '99999') {
      let resInfo = res.info || {};
      resInfo.endPay = ((Number(resInfo.price) * 100 - Number(resInfo.deposit) * 100) / 100).toFixed(2)
      resInfo.d_surplus_pay = ((Number(resInfo.deposit) * 100 - resInfo.deposit_pay) / 100).toFixed(2)
      switch (resInfo.status) {
        case 7:
          resInfo.e_surplus_pay = resInfo.endPay
          break;
        case 8:
          resInfo.e_surplus_pay = ((Number(resInfo.endPay) * 100 - (resInfo.price_pay - resInfo.deposit_pay)) / 100).toFixed(2)
          break;
        case 9:
          resInfo.e_surplus_pay = '0.00'
          break;
        default:
          break;
      }
      commit('UPDATEORDERDETAIL', resInfo);
    }
  },
  // 品牌馆，管理员编辑删除订单已有小项,添加其他小项,修改总额
  async editDelBrandOrder ({ commit, getters,state,dispatch }, {data,flag,successFun}) {
    let loading = _loading({ target: '.load-area' })
    let url, t = getters.storeInfo.type
    let datas = {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      oid:state.OrderDetail.id,
      ...data
    }
    if (t == 99) { 
      delete datas.store_id; delete datas.store_type;
      datas.brandhall_id = Router.currentRoute.query.storeId
    }
    switch (flag) {
      case 0:
        if (t == 8) url = '/pc/Brandhall/delOrderDetails'
        else url = '/pc/Admin/delBrandhallOrderDetails'
        break;
      case 1:
        if (t == 8) url = '/pc/Brandhall/editOrderDetails'
        else url = '/pc/Admin/editBrandhallOrderDetails'
        break;
      case 2:
        if (t == 8) url = '/pc/Brandhall/addOrderDetails'
        else url = '/pc/Admin/addBrandhallOrderDetails'
        break;
      case 3:
        if (t == 8) url = 'pc/Brandhall/setOrderPrice'
        else url = '/pc/Admin/setBrandhallOrderPrice'
        break;
      default:
        break;
    }
    let res = await _axios.post(url, datas)
    loading.close()
    if (res.code === '00000') {
      _alert('操作成功',() => {
        dispatch('getBrandOrderDetail',state.OrderDetail.id);
        if (successFun) successFun(res)
      })
    }
  },
  //确认拒绝取消订单
  async controlBrandOrder ({ commit, getters,state,dispatch }, {data,flag}) {
    let loading = _loading({ target: '.load-area' })
    let url, t = getters.storeInfo.type
    let datas = {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      oid:state.OrderDetail.id,
      ...data
    }
    if (t == 99) { 
      if (flag == 1) {
        delete datas.store_id; delete datas.store_type 
      } else {
        datas.store_id = state.OrderDetail.appoint; datas.store_type = state.OrderDetail.order_style
      }
    }
    if (flag == 1) {
      if (t == 8) url = '/pc/Brandhall/checkOrder'
      else url = 'pc/Admin/checkBrandhallOrder'
    } else {
      if (t == 8) url = '/pc/Brandhall/cancelOrder'
      else url = 'pc/Admin/cancelBrandhallOrder'
    }
    let res = await _axios.post(url, datas)
    loading.close()
    if (res.code === '00000') {
      _alert('操作成功',() => {
        dispatch('getBrandOrderDetail',state.OrderDetail.id);
        dispatch('getWaitHandleData');
      })
    }
  },
  //===============================景区订单操作部分=====================================
  /*采购商、景区、管理员、获取景区订单详情*/
  async getScenicOrderDetail({commit, getters,dispatch},orderId) {
    let t = getters.storeInfo.type, url = '', data = {
      store_id: getters.storeInfo.storeId,
      id: orderId
    };
    switch (t) {
      case 2:
        url = '/pc/Travel/getViewpointOrderDetail';
        break
      case 3:
      case 5:
        url = '/pc/Common/getViewpointOrderDetail';
        break
      case 6:
        url = '/pc/Viewpoint/getOrderDetails';
        delete data.id;
        data.oid = orderId
        break
      case 99:
        url = '/pc/Admin/getViewpointOrderDetails';
        delete data.id;
        data.oid = orderId
        break
    }
    //let loading = _loading({ target: '.load-area' });
    let res = await _axios.post(url, data);
    //loading.close();
    if (res.code === '00000') {
      let resInfo = res.info || {};
      resInfo.surplus_pay = Number(res.info.surplus_pay) || ((Number(res.info.price) * 100 - res.info.price_pay) / 100)
      if (res.info.guide_name && getters.isAdmin) resInfo.guide_id = res.info.order_value_server[0].server_id || ''
      commit('UPDATEORDERDETAIL', resInfo);
      //当订单状态为团队订单待确认时，为景区和管理员拉取团队负责人列表
      if ((t === 6 || t === 99) && resInfo.order_type === 5 && resInfo.status === 14) dispatch('getUserLists')
    }
  },
  /*景区获取订单列表*/
  async scenicGetOrderLists ({ commit, getters }, data) {
    //全部订单状态值重新处理
    if (data.status === 'all') delete data.status
    //let loading = _loading({ target: '.load-area' })
    let res = await _axios.post('/pc/Viewpoint/getOrderList', {
      store_id: getters.storeInfo.storeId,
      num: NUM,
      page: Router.currentRoute.query.page || 1,
      status: '',
      ...data
    })
    //loading.close()
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [];
      let total = res.total_nums || 0;
      commit('UPDATEORDERLISTS', lists)
      commit('UPDATEORDERTOTAL', total)
    }
  },
  /*景区、管理员确认、取消景区订单*/
  async controlScenicOrder ({ commit, getters,state,dispatch }, {data,principal,flag}) {
    let loading = _loading({ target: '.load-area' })
    let url
    if (flag == '1') {
      url = '/pc/Common/confirmViewpointOrder'
      if (state.OrderDetail.order_type === 5) {
        data.viewpoint_user = principal.userName;
        data.viewpoint_mobile = principal.userPhone
      }
    } else url = '/pc/Common/cancelViewpointOrder'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      oid:state.OrderDetail.id,
      ...data
    })
    loading.close()
    if (res.code === '00000') {
      // //确认团队订单时设置景区负责人
      // if (flag === '1' && state.OrderDetail.order_type === 5) {
      //   _axios.post('/pc/Common/editViewpointOrderData', {
      //     store_id: getters.storeInfo.storeId,
      //     oid:state.OrderDetail.id,
      //     viewpoint_user:principal.userName,
      //     viewpoint_mobile:principal.userPhone,
      //   })
      // }
      _alert('操作成功',() => {
        dispatch('getScenicOrderDetail',state.OrderDetail.id);
        dispatch('getWaitHandleData');
      })
    }
  },
  /*设置团队票价格*/
  async setGroupOrderPrice ({ commit, getters,state,dispatch }, data) {
    let loading = _loading({ target: '.load-area' })
    let res = await _axios.post('/pc/Common/setViewpointTicketData', {
      store_id: getters.storeInfo.storeId,
      oid:state.OrderDetail.id,
      price: data
    });
    loading.close();
    if (res.code === '00000') _alert('操作成功', () => dispatch('getScenicOrderDetail',state.OrderDetail.id))
  },
  /*提交年卡订单*/
  async submitYearcardOrder({ commit, getters }, data) {
    let loading = _loading({target:'#submit_card'});
    let res = await _axios.post('/pc/Travel/submitYearcardOrder',{...data});
    loading.close();
    return res;
  },
 /*获取已提交购买年卡的信息*/
  async getAnnualCardInfo({ commit, getters }, data) {
    let loading = _loading({target:'.body_style'});
    let res = await _axios.post('/pc/Travel/getYearcardSingleInfo',{...data});
    loading.close();
   if (res.code === '00000') {
     let infoList = res.data;
     commit('UPDATECARDINFO',infoList);
   }
  },
  /*管理员获取年卡信息*/
  async getYearCardInfo({ commit, getters }, data) {
    let loading = _loading({target:'#admin_yearcard'});
    let res = await _axios.post('/pc/Admin/getYearcardDetail',{...data});
    loading.close();
    if (res.code === '00000') {
      let infoList = res.data;
      commit('UPDATECARDINFO',infoList);
    }
  },
  /*管理员修改年卡状态*/
  async saveYearCardInfo({ commit, getters,state,dispatch }, data) {
    let loading = _loading({target:'#admin_yearcard'});
    let res = await _axios.post('/pc/Admin/saveYearcardOrderShipped',{...data});
    loading.close();
    if (res.code === '00000') {
      dispatch('getWaitHandleData');
      return res;
    }
  },

  /*门店获取相应状态订单的总数*/
  async getOrderNumInfo({ commit, getters,state,dispatch},{listID=0}) {
    return
    let url='',data={};
    switch (getters.storeInfo.type) {
      case 2: url='/pc/Travel/OrderHotelCount'; break;
      case 3: url='/pc/Hotel/OrderHotelCount'; break;
      case 99: url='/pc/Admin/OrderHotelCount'; break;
    }
    if(getters.storeInfo.type===2){
      data={
        uid:listID,
        store_id:getters.storeInfo.storeId
      }
    }if(getters.storeInfo.type===3){
      data={
        store_id:listID==0?getters.storeInfo.storeId:listID
      }
    }
    let res = await _axios.post(url,data);
    if (res.code === '00000') commit('UPDATEORDERNUMINFO',res.data.info);
  },
//=========================度假产品订单操作部分======================================
}
